{
  "title": "Facturación",
  "description": "Gestione su suscripción y los pagos de campañas publicitarias.",
  "tabs": {
    "subscription": "Suscripción",
    "adCampaigns": "Campañas publicitarias"
  },
  "subscription": {
    "price": "Precio",
    "expires": "Vence el",
    "plan": "plan",
    "statusActive": "Activo",
    "statusPending": "Pago pendiente",
    "completePayment": "Completar pago",
    "starting": "Iniciando…",
    "upgradeToPremium": "Actualizar a Premium",
    "upgrading": "Actualizando…",
    "activated": "Suscripción Premium activada",
    "paymentProcessing": "El pago está procesando. Actualice en breve si las funciones permanecen bloqueadas.",
    "payError": "No se pudo iniciar el pago",
    "upgradeSuccess": "Actualizado a Premium. Complete el pago para activar.",
    "upgradeError": "Error al actualizar",
    "couldNotStart": "No se pudo iniciar el pago"
  },
  "adCampaigns": {
    "empty": "Aún no hay campañas publicitarias.",
    "create": "Crear campaña",
    "viewAll": "Ver todas las campañas"
  }
}
